import moment from 'moment'
const columns = (api= {}) => {
  return [
    {
      title: "练习名称",
      name: "name",
      dataIndex: "name",
      tableItem: {width:200},
      searchItem: { },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: '练习状态',
      name: 'status',
      dataIndex: "status",
      searchItem: { type: 'select' },
      tableItem: {width:100},
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ]
    },
    {
      title: '练习时间',
      name: 'practiceDate',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD'
      }
    },
    {
      title: '开始时间',
      name: 'startDate',
      dataIndex: "startDate",
      tableItem: {width:160}
    },
    {
      title: '结束时间',
      name: 'endDate',
      dataIndex: "endDate",
      tableItem: {width:160}
    },
    {
      title: '推送时间',
      name: 'pushTime',
      dataIndex: "pushTime",
      tableItem: {
        width: 150,
        render: (text) => {
          if (text) {
            text = text.slice(0,5)
          }
          return text
        }
      }
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'practice/list',
    ...api
  }
}

const practice = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(api),
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['practiceDate'] && value['practiceDate'].length === 2) {
          value['startDate'] = moment(value['practiceDate'][0]).format("YYYY/MM/DD 00:00:00")
          value['endDate'] = moment(value['practiceDate'][1]).format("YYYY/MM/DD 23:59:59")
        }
        delete value['practiceDate']

        return value
      }
    },
  }
}

export default practice
